import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './module/userInfo'
import loading from './module/loading'

Vue.use(Vuex);

// 创建 store 实例
export default new Vuex.Store({
  modules: {
    userInfo,
    loading
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js